import { Icon, TextLink } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

interface SettingsDocsLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * A link out to documentation, set inline at the end of a description. The
 * arrow, not a link color, is what marks it as leaving the app, so it keeps the
 * text color and only dims on hover.
 */
export const SettingsDocsLink = ({
  href,
  children,
  className,
}: SettingsDocsLinkProps) => (
  <TextLink
    variant="secondary"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={clsx('inline-flex gap-0.75 hover:text-secondary', className)}
  >
    {children}
    <Icon icon="ArrowNE" className="h-3 w-3" />
  </TextLink>
);
